class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      
      const isMessageCard = this.getAttribute('data-is-message-card') === 'true';
      
      if (isMessageCard) {
        const modal = document.querySelector('.message-card-confirm-modal');
        if (modal) {
          modal.classList.remove('hide');
          document.body.classList.add('modal-opened');
          
          modal.dataset.removeButtonId = this.id;
          modal.dataset.removeButtonIndex = this.dataset.index;
          modal.dataset.removeButtonKey = this.dataset.key;
          modal.dataset.removeButtonBundleId = this.getAttribute('all-bundle_id');
          modal.dataset.removeButtonDataId = this.getAttribute('data-id');
        }
        return;
      }
      
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');      
      var all_bundle_id = this.getAttribute('all-bundle_id');
      var all_bundle_data_id = this.getAttribute('data-id');

      //console.log('all_bundle_data_id = '+all_bundle_data_id+' and all_bundle_id = '+all_bundle_id);

      if(all_bundle_id && all_bundle_data_id == 'main_bundle_id' ){
        console.log('if'+all_bundle_id);
        var bundle_items = document.querySelectorAll(`[all-bundle_id="${all_bundle_id}"]`);
        var updateObj = {};
        bundle_items.forEach((bundle_item, i) =>{
          //console.log(bundle_item.dataset);
          //var forEach_index = i+1;
          //console.log(bundle_item.dataset.index+' = '+forEach_index);
          // setTimeout(() => {          
          // cartItems.updateQuantity(forEach_index, 0);
          // }, bundle_item.dataset.index );
          updateObj[bundle_item?.dataset?.key] = 0;
        })
        cartItems.updateBundleQuantity(updateObj);
        }else{
          cartItems.updateQuantity(this.dataset.index, 0);
          console.log('else'+all_bundle_id);
        }      
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);






class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
   //Added by Gyrovi dev
   const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');      
   var all_bundle_id = event.target.dataset.main_bundle_id;
   //console.log({all_bundle_id});

   if(all_bundle_id && event.target.value == 0){
     var bundle_items = document.querySelectorAll(`[all-bundle_id="${all_bundle_id}"]`);
     var updateObj = {};
     bundle_items.forEach((bundle_item, i) =>{
       updateObj[bundle_item?.dataset?.key] = 0;
     })
     //console.log({updateObj});
     cartItems.updateBundleQuantity(updateObj);
   } else {
     this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
   }
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
          //dispatch custom event
          const customEvent = new CustomEvent("cart:modified");
          document.dispatchEvent(customEvent);
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          console.log(html);
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
          //dispatch custom event
          const customEvent = new CustomEvent("cart:modified");
          document.dispatchEvent(customEvent);
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  isCheckoutDisabled(parsedState) {
   const sectionHtml = parsedState.sections[document.getElementById('main-cart-footer').dataset.id];
   const html = new DOMParser().parseFromString(sectionHtml, 'text/html');
   return html?.querySelector('button[name="checkout"]')?.dataset?.ipc ?? false;
  }

  getIPCErrorText(parsedState) {
    const sectionHtml = parsedState.sections[document.getElementById('main-cart-items').dataset.id];
    const html = new DOMParser().parseFromString(sectionHtml, 'text/html');
    return html?.querySelector('.ipc-disabled-error-message')?.dataset?.html ?? null;
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateBundleQuantity(itemsObject) {
    if(!itemsObject) return;
    this.enableLoading();

    const body = JSON.stringify({
      updates: itemsObject,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const ipcErrorText = this.getIPCErrorText(parsedState);
        const isCheckoutDisabled = this.isCheckoutDisabled(parsedState);
        // const quantityElement =
        //   document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        // const items = document.querySelectorAll('.cart-item');

        // if (parsedState.errors) {
        //   quantityElement.value = quantityElement.getAttribute('value');
        //   this.updateLiveRegions(line, parsedState.errors);
        //   return;
        // }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          if(elementToReplace){
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        });
        // const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        // let message = '';
        // if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
        //   if (typeof updatedValue === 'undefined') {
        //     message = window.cartStrings.error;
        //   } else {
        //     message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
        //   }
        // }
        //this.updateLiveRegions(line, message);

        // const lineItem =
        //   document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        // if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
        //   cartDrawerWrapper
        //     ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
        //     : lineItem.querySelector(`[name="${name}"]`).focus();
        // } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
        //   trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        // } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
        //   trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        // }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState });
        //dispatch custom event
        const customEvent = new CustomEvent("cart:modified", { detail: { isCheckoutDisabled: isCheckoutDisabled, ipcErrorText: ipcErrorText }});
        document.dispatchEvent(customEvent);
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        location.reload();
      })
      .finally(() => {
        this.disableLoading();
      });
  }

  updateQuantity(line, quantity, name, variantId) {
    //console.log('line = '+line);
    if(typeof line === 'undefined') return;
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');
        const ipcErrorText = this.getIPCErrorText(parsedState);
        const isCheckoutDisabled = this.isCheckoutDisabled(parsedState);

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          if(elementToReplace){
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          } 
        });

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }


        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        //dispatch custom event
        const customEvent = new CustomEvent("cart:modified", { detail: { isCheckoutDisabled: isCheckoutDisabled, ipcErrorText: ipcErrorText }});
        document.dispatchEvent(customEvent);
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        location.reload();
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    if(line){
      const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
      const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);
      [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));
    }
    
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    if(line){
      const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
      const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

      cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
      cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    }
    
  }

  lockCartForMessageCard() {
    const mainCartItems = document.getElementById("main-cart-items");
    mainCartItems?.classList.add("cart__items--message-card-locked");
  }

  unlockCartForMessageCard() {
    const mainCartItems = document.getElementById("main-cart-items");
    mainCartItems?.classList.remove("cart__items--message-card-locked");
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

document.addEventListener('cart:modified', (event) => {
  const isCheckoutDisabled = event?.detail?.isCheckoutDisabled;
  const ipcErrorText = event?.detail?.ipcErrorText;
  if(isCheckoutDisabled === 'disabled'){
    document.querySelector('.ipc-disabled-error-message').innerHTML = ipcErrorText || '';
    document?.querySelector('[name="checkout"]')?.setAttribute('disabled', 'disabled');
    document?.querySelector('[name="checkout"]')?.removeAttribute('type');
    document?.querySelector('[name="checkout"]')?.classList.add('disabled');
    document?.querySelector('.dynamic-checkout__content')?.classList.add('hide');
  } else {
    document.querySelector('.ipc-disabled-error-message').innerHTML = '';
    document?.querySelector('[name="checkout"]')?.removeAttribute('disabled');
    document?.querySelector('[name="checkout"]')?.setAttribute('type', 'submit');
    document?.querySelector('[name="checkout"]')?.classList.remove('disabled');
    document?.querySelector('.dynamic-checkout__content')?.classList.remove('hide');
  }
})

document.addEventListener('click', (e) => {
  const messageCardModal = document.querySelector('.message-card-confirm-modal');
  if (!messageCardModal) return;
  
  const closeModal = () => {
    messageCardModal.classList.add('hide');
    document.body.classList.remove('modal-opened');
    delete messageCardModal.dataset.removeButtonId;
    delete messageCardModal.dataset.removeButtonIndex;
    delete messageCardModal.dataset.removeButtonKey;
    delete messageCardModal.dataset.removeButtonBundleId;
    delete messageCardModal.dataset.removeButtonDataId;
  };

  if (e.target.closest('.message-card-confirm-modal .overlay') || 
      e.target.closest('.message-card-confirm-modal .close-modal') || 
      e.target.closest('.message-card-confirm-modal .confirm-no')) {
    closeModal();
  } else if (e.target.closest('.message-card-confirm-modal .confirm-yes')) {
    const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
    const index = messageCardModal.dataset.removeButtonIndex;
    if (!cartItems) return;
    closeModal();
    cartItems.lockCartForMessageCard();
    cartItems.updateQuantity(index, 0);
  }
});